//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import ForumForm from 'app_components/modules/admin/forum'
import ForumSkeleton from './forumSkeleton'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import ModalForumCategory from 'app_components/modules/ModalForumCategory/ModalForumCategory';
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IForumListItem } from 'app_types/admin/forum/forumTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../forumScreen.scss'

// @ADD Component types
interface IForumScreenLayoutProps {
	itemList: IForumListItem[]
  status: null | 'loading' | 'error'
  add: boolean
  edit: boolean
  view: boolean
  editData: any
  selectedRow: null | string
  pagination: IPagination
  addItem: any
  updateItem: any
  showAddForm: (add: boolean) => void
  showEditForm: (edit: boolean, editData?: any) => void
  onViewerRow: (view: boolean, editData?: any) => void
  onPageChange: (page: number) => void
  onRowClick: (row: any) => void
  removeItem: (userId: string) => void
  onSearch: (search: string) => void
}

const ForumScreenLayout: React.FC<IForumScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [openCategories, updateOpenCategories] = useState<boolean>(false)

  return(
    <AppContainer>
      <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.forums')}`]} />

        <div className='forum-screen'>

          {props.status === 'loading' && (
            <ForumSkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t('screens.forums.title')}</h2>
              <ButtonComponent
                variant='primary'
                onClick={() => updateOpenCategories(true)}
              >
                Ver categorías
              </ButtonComponent>
              <DataTableComponent
                data={props.itemList}
                headerKeys={[
                  `${t('components.dataTable.headers.forums.title')}`,
                  `${t('components.dataTable.headers.forums.postDate')}`,
                  `${t('components.dataTable.headers.forums.isActive')}`,
                ]}
                keys={['title', 'postDate', 'isActive']}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[
                  { name: `${t('components.dataTable.details.forums.locations')}`, key: 'locations.forumLocation.name', listItem: true },
                  { name: `${t('components.dataTable.details.forums.description')}`, key: 'description', listItem: true },
                ]}
                onSearch={props.onSearch}
                onAddRow={props.showAddForm}
                onClickRow={props.onRowClick}
                onRemoveRow={props.removeItem}
                onPageChange={props.onPageChange}
                onEditRow={props.showEditForm}
                onViewerRow={props.onViewerRow}
                onModal={null}
              />
            </>
          )}

          {props.add && (
            <div className="forum-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                <h2 className="form-title">
                  {t("screens.forums.add_layout.title_page")}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showAddForm(false)}>
                  {t("buttons.back")}
                </button>
              </div>
              <ForumForm
                onHandleSubmit={props.addItem}
                viewer={false}
              />
            </div>
          )}

          {(props.edit || props.view) && props.editData && (
            <div className="forum-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                {props.edit && (
                  <>
                    <h2 className="form-title">
                      {t("screens.forums.edit_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showEditForm(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
                {props.view && (
                  <>
                    <h2 className="form-title">
                      {t("screens.forums.view_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.onViewerRow(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
              </div>
              <ForumForm
                editData={props.editData}
                onHandleSubmit={props.updateItem}
                viewer={props.view}
              />
            </div>
          )}
          <ModalForumCategory
            open={openCategories}
            onClose={() => updateOpenCategories(false)}
          />
        </div>
      </div>
    </AppContainer>
  )
}

export default ForumScreenLayout
